/**
 * A strip of tabs wider than its box (Financiero's six sections on a phone)
 * scrolls sideways without a bar (`no-scrollbar`, like the FilterBar chips),
 * so the active tab has to be brought into view by the strip itself — a tab
 * chosen from the URL or with the arrow keys could otherwise sit cut off at
 * the edge.
 *
 * Pure maths, so it is tested without a DOM: given the strip's visible width
 * and scroll, and the tab's offset and width inside it, the `scrollLeft` that
 * shows the whole tab with `margin` px of air — or the same `scrollLeft` when
 * it is already in view (a strip that does not overflow never moves, which is
 * what keeps the desktop exactly as it was).
 */
export function revealTabScrollLeft(
    strip: { scrollLeft: number; clientWidth: number; scrollWidth: number },
    tab: { offsetLeft: number; offsetWidth: number },
    margin = 16,
): number {
    const { scrollLeft, clientWidth, scrollWidth } = strip;
    if (scrollWidth <= clientWidth) return scrollLeft;
    const max = scrollWidth - clientWidth;
    const start = tab.offsetLeft - margin;
    const end = tab.offsetLeft + tab.offsetWidth + margin;
    let next = scrollLeft;
    if (start < scrollLeft) next = start;
    else if (end > scrollLeft + clientWidth) next = end - clientWidth;
    return Math.max(0, Math.min(max, next));
}
